import { useEffect, useState, useCallback, useRef } from "react";
import { IDLE_LOCK_MINUTES } from "../lib/config";

const LOCK_AFTER_MS = IDLE_LOCK_MINUTES * 60 * 1000;
const TICK_MS = 1000;

export function useIdleLock() {
  const [secondsRemaining, setSecondsRemaining] = useState(IDLE_LOCK_MINUTES * 60);
  const [locked, setLocked] = useState(false);
  const lastActivityRef = useRef<number>(Date.now());

  const reset = useCallback(() => {
    if (locked) return;
    lastActivityRef.current = Date.now();
    setSecondsRemaining(IDLE_LOCK_MINUTES * 60);
  }, [locked]);

  useEffect(() => {
    if (locked) return;
    const events: (keyof WindowEventMap)[] = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    const id = setInterval(() => {
      const elapsed = Date.now() - lastActivityRef.current;
      const remaining = Math.max(0, LOCK_AFTER_MS - elapsed);
      setSecondsRemaining(Math.ceil(remaining / 1000));
      if (remaining <= 0) setLocked(true);
    }, TICK_MS);
    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      clearInterval(id);
    };
  }, [reset, locked]);

  const unlock = useCallback(() => {
    lastActivityRef.current = Date.now();
    setSecondsRemaining(IDLE_LOCK_MINUTES * 60);
    setLocked(false);
  }, []);

  return { locked, secondsRemaining, unlock };
}
